var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "#D1E0E6"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 62,
    width: 22,
    height: 21,
    fill: "#BDD2DA"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 21,
    width: 22,
    height: 41,
    fill: "#C4D9E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    width: 22,
    height: 21,
    fill: "#DCE8ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 62,
    width: 22,
    height: 21,
    fill: "#D6E6EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 21,
    width: 22,
    height: 41,
    fill: "#CBDDE5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    width: 39,
    height: 21,
    fill: "#C0CFD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 62,
    width: 39,
    height: 21,
    fill: "#C3DCE6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 39,
    height: 41,
    fill: "#B2C3CA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.1c1bb5141c1dc08b2aaab04809795cee.svg";
export { ForwardRef as ReactComponent };